import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { TrialActionType, TrialActivityData } from "./types";

// Global state atom for trial ending notification
export const trialEndingNotificationAtom = atom<{
  isVisible: boolean;
  daysLeft: number;
  actionType: TrialActionType;
  containerRef?: React.RefObject<HTMLElement> | null;
  stackContainerRef?: React.RefObject<HTMLElement> | null;
  chatContainerRef?: React.RefObject<HTMLElement> | null;
}>({
  isVisible: false,
  daysLeft: 99,
  actionType: TrialActionType.Chat,
  containerRef: null,
  stackContainerRef: null,
  chatContainerRef: null,
});

const defaultTrialActivityData: TrialActivityData = {
  lastSearchDate: undefined,
};

/**
 * This atom is used for tracking local user activity that might be a pre-condition for displaying certain upsells.
 */
export const trialActivityAtom = atomWithStorage(
  "trialData",
  defaultTrialActivityData,
);
